import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import Vue from "vue";

const state = {
  library: {
    folders: null,
    files: null,
  },
  currentFolder: null,
  currentFolderMeta: null,
  currentFilePreviews: [],
};

const getters = {
  library_get_library_list: (state) => {
    return state.library;
  },
  library_get_current_folder: (state) => {
    return state.currentFolder;
  },
  library_get_current_folder_breadcrumbs: (state) => {
    return state.currentFolderMeta && state.currentFolderMeta.breadcrumbs ? state.currentFolderMeta.breadcrumbs : [];
  },
  library_get_library_file_previews: (state) => {
    return state.currentFilePreviews;
  },
};

const mutations = {
  LIBRARY_SET_LIBRARY_FOLDER_LIST(state, folders) {
    const f = folders.sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0));
    Vue.set(state.library, "folders", f);
  },
  LIBRARY_SET_LIBRARY_FILE_LIST(state, files) {
    Vue.set(state.library, "files", files);
  },
  LIBRARY_RESET_LIBRARY_FILE_LIST(state) {
    Vue.set(state.library, "files", []);
  },
  LIBRARY_SET_LIBRARY_FILE_PREVIEWS(state, previews) {
    state.currentFilePreviews = previews;
  },
  LIBRARY_SET_CURRENT_FOLDER(state, folder) {
    state.currentFolder = folder;
  },
  LIBRARY_SET_CURRENT_FOLDER_META(state, meta) {
    state.currentFolderMeta = meta;
  },
};

const actions = {
  getLibraryFoldersList({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "1000",
        order_col: payload.params.order_col ? payload.params.order_col : "title",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        search: payload.params.search ? payload.params.search : "",
        root_folder: payload.folder ? payload.folder : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersGet(params)
            .then((res) => {
              console.log("teamLibraryFoldersGet", res);
              if (!payload.preventSetStoreState) commit("LIBRARY_SET_LIBRARY_FOLDER_LIST", res.data.data);
              // if (payload.setListsSettings) {
              //   commit('GLOBAL_SET_LISTS_SETTINGS', {
              //     list: 'libraryFolders',
              //     pagination: {
              //       page: res.data.meta.pagination.current_page,
              //       perPage: res.data.meta.pagination.per_page,
              //       lastPage: res.data.meta.pagination.last_page,
              //       total: res.data.meta.pagination.total
              //     },
              //     order: {
              //       col: params.order_col,
              //       dir: params.order_dir
              //     },
              //     search: params.search,
              //     filter: {}
              //   })
              // }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              commit("LIBRARY_SET_LIBRARY_FOLDER_LIST", []);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              console.log("error", err);
              reject(err);
            });
        })
        .catch((err) => {
          commit("LIBRARY_SET_LIBRARY_FOLDER_LIST", []);
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          console.log("error", err);
          reject(err);
        });
    });
  },
  getLibraryFilesList({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "updated_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        folder: payload.folder,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesGet(params)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesGet", res);
              commit("LIBRARY_SET_LIBRARY_FILE_LIST", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "libraryFiles",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  // search: params.search,
                  // filter: {}
                });
              }
              // commit('GLOBAL_LOADING_ENDED')
              // resolve(res)
              // let promises = []
              // let filePreviews = []
              // res.data.data.forEach((obj) => {
              //   if (((obj.status & res.data.meta.status.CONVERTED.bit) === res.data.meta.status.CONVERTED.bit)) {
              //     const previewParams = {
              //       customLoading: true,
              //       team: params.team,
              //       folder: payload.folder,
              //       file: obj.uid,
              //       width: '70',
              //       height: '70'
              //     }
              //     promises.push(
              //       dispatch('getLibraryFilePreview', previewParams).then((res) => {
              //         filePreviews.push({ uid: obj.uid, url: res })
              //       }).catch((err) => {
              //         console.log(err)
              //       })
              //     )
              //   }
              // })
              // Promise.all(promises).then(() => {
              //   commit('LIBRARY_SET_LIBRARY_FILE_PREVIEWS', filePreviews)
              //   resolve()
              //   commit('GLOBAL_LOADING_ENDED')
              // }).catch((err) => {
              //   reject(err)
              //   commit('GLOBAL_LOADING_ENDED')
              // })
              resolve();
              commit("GLOBAL_LOADING_ENDED");
            })
            .catch((err) => {
              console.log("error", err);
              commit("LIBRARY_SET_LIBRARY_FILE_LIST", []);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("error", err);
          commit("LIBRARY_SET_LIBRARY_FILE_LIST", []);
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getLibraryFolder({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderGet(params)
            .then((res) => {
              console.log("teamLibraryFoldersFolderGet", res);
              if (payload.setCurrent) {
                commit("LIBRARY_SET_CURRENT_FOLDER", res.data.data);
                commit("LIBRARY_SET_CURRENT_FOLDER_META", res.data.meta);
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("library folder get err", err);
              $errors.handle(err.response, { name: "library" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("library folder get err 2", err);
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getLibraryFile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.customLoading) commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFileGet(params)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFileGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response, { name: "library" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  downloadLibraryFile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFileDownloadGet(params)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFileDownloadGet", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getLibraryFilePreview({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        team: payload.team,
        folder: payload.folder,
        file: payload.file,
        any: "",
        redirect: payload.params.redirect ? payload.params.redirect : false,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFilePreviewFileAnyGet(params)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFilePreviewFileAnyGet", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data.redirect);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getLibraryImagePreview({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        team: payload.team,
        folder: payload.folder,
        file: payload.file,
        page: payload.params.page ? payload.params.page : "1",
        width: payload.params.width ? payload.params.width : "100",
        height: payload.params.height ? payload.params.height : "100",
        rendermethod: payload.params.rendermethod ? payload.params.rendermethod : "fit",
        redirect: payload.params.redirect ? payload.params.redirect : false,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFilePreviewImageRendermethodPageWidthHeightGet(params)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFilePreviewImageRendermethodPageWidthHeightGet", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data.redirect);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editLibraryFile({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFilePut(params, payload.data)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFilePut", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response, { name: "file" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createLibraryFolder({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {})
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersPost(params, payload.data)
            .then((res) => {
              console.log("teamLibraryFoldersPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editLibraryFolder({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", { folder: state.currentFolder.uid })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderPut(params, payload.data)
            .then((res) => {
              console.log("teamLibraryFoldersFolderPut", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteLibraryFolder({ commit, dispatch, state, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", { folder: state.currentFolder.uid })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderDelete(params, {})
            .then((res) => {
              console.log("teamLibraryFoldersFolderDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteLibraryFile({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {
        folder: state.currentFolder.uid,
        file: payload.file,
      })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFileDelete(params, {})
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFileDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve();
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createLibraryFolderFile({ commit, dispatch, rootState, state }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", { folder: state.currentFolder.uid })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesPost(params, payload.data)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  listPartsLibraryFolderFile({ commit, dispatch, rootState, state }, payload) {
    return new Promise((resolve, reject) => {
      // commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {
        folder: state.currentFolder.uid,
        file: payload.file,
        upload_id: payload.data.upload_id,
      })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFilePartsGet(params, {})
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFileCompletePost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  signLibraryFolderFile({ commit, dispatch, rootState, state }, payload) {
    return new Promise((resolve, reject) => {
      // commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {
        folder: state.currentFolder.uid,
        file: payload.file,
      })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFileSignPost(params, payload.data)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFileSignPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  abortLibraryFolderFile({ commit, dispatch, rootState, state }, payload) {
    return new Promise((resolve, reject) => {
      // commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {
        folder: state.currentFolder.uid,
        file: payload.file,
        upload_id: payload.data.upload_id,
      })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFileAbortDelete(params, {})
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFileAbortDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(true);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  completeLibraryFolderFile({ commit, dispatch, rootState, state }, payload) {
    return new Promise((resolve, reject) => {
      // commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {
        folder: state.currentFolder.uid,
        file: payload.file,
      })
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamLibraryFoldersFolderFilesFileCompletePost(params, payload.data)
            .then((res) => {
              console.log("teamLibraryFoldersFolderFilesFileCompletePost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
